import React from "react";

export const PlusIcon = React.memo(() => {
    return (
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6.75 0.75V12.75M0.75 6.75H12.75" stroke="#757575" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    )
});